export enum UserInfoActionTypes {
    LIST_REQUEST = '@@UserInfo/LIST_REQUEST',
    LIST_SUCCESS = '@@UserInfo/LIST_SUCCESS',
    LIST_ERROR = '@@UserInfo/LIST_ERROR',
    LIST_CLEAR = '@@UserInfo/LIST_CLEAR',

    SELECT = '@@UserInfo/SELECT',
    SELECTED = '@@UserInfo/SELECTED',
    CLEAR_SELECTED = '@@UserInfo/CLEAR_SELECTED',
    
}

export interface UserInfoUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
}
